module.exports = __webpack_public_path__ + "static/media/img_patient_finish.c4249e25.svg";